import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions FR
import commonFr from './locales/fr/common.json';
import headerFr from './locales/fr/header.json';
import sidebarFr from './locales/fr/sidebar.json';
import footerFr from './locales/fr/footer.json';
import facturationFr from './locales/fr/facturation.json';

// Import des traductions EN
import commonEn from './locales/en/common.json';
import headerEn from './locales/en/header.json';
import sidebarEn from './locales/en/sidebar.json';
import footerEn from './locales/en/footer.json';
import facturationEn from './locales/en/facturation.json';

// Configuration des ressources de traduction
const resources = {
  fr: {
    common: commonFr,
    header: headerFr,
    sidebar: sidebarFr,
    footer: footerFr,
    facturation: facturationFr,
  },
  en: {
    common: commonEn,
    header: headerEn,
    sidebar: sidebarEn,
    footer: footerEn,
    facturation: facturationEn,
  },
};

i18n
  // Détection automatique de la langue
  .use(LanguageDetector)
  // Intégration avec React
  .use(initReactI18next)
  // Configuration
  .init({
    resources,
    
    // Langue par défaut
    fallbackLng: 'fr',
    
    // Langue initiale (FORCER le français comme première option)
    lng: 'fr',
    
    // Namespace par défaut
    defaultNS: 'common',
    
    // Namespaces disponibles
    ns: ['common', 'header', 'sidebar', 'footer', 'facturation'],
    
    // Configuration de la détection
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tradeVaultLanguage',
      
      // Options pour ne pas prioriser la langue du navigateur
      convertDetectedLanguage: (lng) => {
        // Vérifier d'abord le localStorage
        const savedLang = localStorage.getItem('tradeVaultLanguage');
        if (savedLang && (savedLang === 'fr' || savedLang === 'en')) {
          return savedLang;
        }
        // Sinon, retourner 'fr' par défaut
        return 'fr';
      },
    },
    
    // Interpolation
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
    
    // Mode debug (à désactiver en production)
    debug: false,
  });

// S'assurer que le français est bien chargé au démarrage
const savedLang = localStorage.getItem('tradeVaultLanguage');
if (!savedLang) {
  localStorage.setItem('tradeVaultLanguage', 'fr');
}

export default i18n;